import { WebGLRenderer } from 'three';

export class VRButton {
    static xrSessionIsGranted = false;

    static async startSession(
        renderer: WebGLRenderer,
        sessionInit: any = {},
    ): Promise<XRSession> {
        const sessionOptions = {
            ...sessionInit,
            optionalFeatures: [
                'local-floor',
                'bounded-floor',
                ...(sessionInit.optionalFeatures || []).filter((f: string) => f !== 'layers'),
            ],
        };

        const session: XRSession = await (navigator as any).xr.requestSession('immersive-vr', sessionOptions);

        const xrBinding = (window as any).XRWebGLBinding;
        const savedCPL = xrBinding?.prototype?.createProjectionLayer;
        if (savedCPL) delete xrBinding.prototype.createProjectionLayer;

        try {
            await renderer.xr.setSession(session);
        } finally {
            if (savedCPL) xrBinding.prototype.createProjectionLayer = savedCPL;
        }
        return session;
    }

    static registerSessionGrantedListener() {
        if (typeof navigator !== 'undefined' && 'xr' in navigator) {
            if (/WebXRViewer\//i.test(navigator.userAgent)) return;

            (navigator as any).xr.addEventListener('sessiongranted', () => {
                VRButton.xrSessionIsGranted = true;
            });
        }
    }
}

VRButton.registerSessionGrantedListener();
